import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import {
  ASYNC_CREATE_PROFILE,
  ASYNC_EDIT_PROFILE,
  ASYNC_DELETE_PROFILE,
  ASYNC_RESTORE_PROFILE,
  LOADING
} from 'store';

function* createProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'profiles', payload, {
      headers: { 
        'X-Success-Message': 'Perfil Cadastrado com sucesso',
        'X-Redirect': '/profiles',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.put, `profiles/${payload.id}`, payload, {
      headers: { 
        'X-Success-Message': 'Perfil Atualizado com sucesso', 
        'X-Redirect': '/profiles',
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* deleteProfile({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.delete, `profiles/${payload.id}`, {
      headers: {
        'X-Success-Message': 'Perfil desativado com sucesso', 
        'X-Redirect': '/profiles',
        'X-Refresh': true,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* restoreProfile({ payload: { id } }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.get, `profiles/restore/${id}`, {
      headers: {
        'X-Success-Message': 'Perfil reativado com sucesso', 
        'X-Redirect': '/profiles/trash',
        'X-Refresh': true,
        'X-Show-Alert': true
      }
    });
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_PROFILE, createProfile),
    takeLatest(ASYNC_EDIT_PROFILE, editProfile),
    takeLatest(ASYNC_DELETE_PROFILE, deleteProfile),
    takeLatest(ASYNC_RESTORE_PROFILE, restoreProfile)
  ]);
}
